var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 165C135.899 165 165 135.899 165 100C165 64.1015 135.899 35 100 35C64.1015 35 35 64.1015 35 100C35 135.899 64.1015 165 100 165Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.023 54.8965C132.023 54.6956 132.248 54.5764 132.414 54.6895L175.277 84.0205C175.422 84.1199 175.421 84.3334 175.276 84.4326L132.414 113.757C132.248 113.87 132.023 113.752 132.023 113.551V97.2334C132.023 96.267 131.24 95.4835 130.273 95.4834H107.594C107.539 95.4834 107.485 95.4651 107.441 95.4316L78.8203 73.4111C78.6315 73.2656 78.7342 72.9631 78.9727 72.9629H130.273C131.24 72.9628 132.023 72.1793 132.023 71.2129V54.8965Z",
    fill: "#AEAEAE",
    stroke: "#AEAEAE",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4854 93.1158C72.6513 93.0024 72.877 93.1219 72.877 93.3229V109.646C72.877 110.613 73.6605 111.396 74.627 111.396H113.92C114.158 111.396 114.261 111.699 114.072 111.844L85.4521 133.858C85.4085 133.892 85.3549 133.91 85.2998 133.91H74.627C73.6605 133.91 72.877 134.693 72.877 135.66V151.977C72.8769 152.178 72.6512 152.297 72.4854 152.183L29.6299 122.859C29.4848 122.76 29.4848 122.546 29.6299 122.447L72.4854 93.1158Z",
    fill: "#AEAEAE",
    stroke: "#AEAEAE",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M173.033 81.3853C173.614 80.9882 173.614 80.1318 173.033 79.7347L130.171 50.4041C129.507 49.95 128.606 50.4252 128.606 51.2294V67.5467C128.606 68.099 128.159 68.5467 127.606 68.5467H76.3059C75.3511 68.5467 74.9394 69.7571 75.6961 70.3393L104.317 92.3593C104.491 92.4938 104.706 92.5667 104.926 92.5667H127.606C128.159 92.5667 128.606 93.0144 128.606 93.5667V109.884C128.606 110.688 129.507 111.164 130.171 110.71L173.033 81.3853Z",
    fill: "#36A635"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.539 119.812C25.9586 119.415 25.9586 118.558 26.5389 118.161L69.3948 88.8307C70.0585 88.3765 70.9596 88.8517 70.9596 89.6559V105.98C70.9596 106.532 71.4074 106.98 71.9596 106.98H111.253C112.207 106.98 112.619 108.19 111.862 108.772L83.2426 130.786C83.0678 130.92 82.8534 130.993 82.6329 130.993H71.9596C71.4074 130.993 70.9596 131.441 70.9596 131.993V148.31C70.9596 149.115 70.0586 149.59 69.3949 149.136L26.539 119.812Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9801 92.5665H127.333C128.033 92.5665 128.6 93.1332 128.6 93.8332V109.373C128.6 110.393 129.74 110.993 130.587 110.42L172.707 81.5998C173.44 81.0932 173.44 80.0065 172.707 79.5065L130.587 50.6865C129.747 50.1132 128.6 50.7132 128.6 51.7332V67.2732C128.6 67.9732 128.033 68.5398 127.333 68.5398H63.7534",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.987 58.9398H70.96",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0397 68.5465H52.2397",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3799 130.993H72.2266C71.5266 130.993 70.96 131.56 70.96 132.26V147.8C70.96 148.82 69.82 149.42 68.9733 148.847L26.8532 120.027C26.1199 119.52 26.1199 118.433 26.8532 117.933L68.9733 89.1133C69.8133 88.5399 70.96 89.1399 70.96 90.1599V105.7C70.96 106.4 71.5266 106.967 72.2266 106.967H106.987",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M113.707 106.98H118.507",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M104.1 130.993H130.514",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M137.233 130.993H142.033",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M116.593 140.6H150.22",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/Connect.4e3418e80ba09d03ebbb245188fd87e7.svg";
export { ForwardRef as ReactComponent };